import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './components/login/login.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LogoutComponent } from './components/logout/logout.component';
import { AuthComponent } from './auth.component';
import { TranslationModule } from '../i18n/translation.module';
import { ConfirmRegistrationComponent } from './components/confirm-registration/confirm-registration.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { UserRegistrationStep1Component } from './modals/user-registration-step1/user-registration-step1.component';
import { UserRegistrationStep2Component } from './modals/user-registration-step2/user-registration-step2.component';
import { SiteSelectComponent } from './components/site-select/site-select.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { ContactUsComponent } from './components/contact-us/contact-us.component';

@NgModule({
  declarations: [
    LoginComponent,
    RegistrationComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    LogoutComponent,
    AuthComponent,
    ConfirmRegistrationComponent,
    UserRegistrationStep1Component,
    UserRegistrationStep2Component,
    SiteSelectComponent,
    ContactUsComponent
  ],
  imports: [
    CommonModule,
    NgbTooltipModule,
    TranslationModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RecaptchaModule
  ],
  exports: [
    UserRegistrationStep1Component,
    UserRegistrationStep2Component,
    SiteSelectComponent
  ]
})
export class AuthModule {}
